import { action, createRequestTypes } from "../../actions";

export const LOAD_SERVICES = createRequestTypes("LOAD_SERVICES");

export const loadServices = {
  request: () => action(LOAD_SERVICES.REQUEST, { }),
  success: response => action(LOAD_SERVICES.SUCCESS, { response }),
  failure: error => action(LOAD_SERVICES.FAILURE, { error }),
};
